import {
    Box,
    Button,
    Progress,
    Text,
    Icon,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Flex,
    Link
} from "@chakra-ui/react";
import { NavLink } from "react-router";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider"

export const OnboardingSteps = ({ onboarding, stripeOnboardingUrl, publisher }) => {

    const { addBreadcrumb } = useBreadcrumbs();

    return (
        <Box p={6} mx="auto">
            <Text fontSize="lg" fontWeight="bold">Onboarding Steps</Text>
            <Text fontSize="sm" color="gray.600">
                Follow these steps to set up your own website.
            </Text>

            <Progress value={`${publisher?.otherInfo?.isStoreSettingComplete && publisher?.otherInfo?.isOnBoardingCompleted ? 100 : publisher?.otherInfo?.isStoreSettingComplete ? 67 : 34}`} size="sm" colorScheme="blue" mt={4} mb={6} />

            <Accordion allowMultiple defaultIndex={[1]}>
                {/* Step 1 */}
                <AccordionItem background="#fff" borderRadius="5px" border="none" padding="10px 8px" margin={"0 0 10px 0"}>
                    <AccordionButton>
                        <Icon as={CheckCircleIcon} color="green.500" />
                        <Flex flex="1" textAlign="left" paddingLeft={2}>
                            <Text fontWeight="bold">Sign Up</Text>
                        </Flex>
                        <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4}>
                        <Text fontSize="md" color="green.600">
                            Congratulations on your successful registration!.
                        </Text>
                    </AccordionPanel>
                </AccordionItem>

                {/* Step 2 */}
                <AccordionItem background="#fff" borderRadius="5px" border="none" padding="10px 8px" margin={"0 0 10px 0"}>
                    <AccordionButton>
                        <Icon as={CheckCircleIcon} color={publisher?.otherInfo?.isStoreSettingComplete ? "green.500" : "gray.500"} />
                        <Flex flex="1" textAlign="left" paddingLeft={2}>
                            <Text fontWeight="bold">Update Store information</Text>
                        </Flex>
                        <AccordionIcon />
                    </AccordionButton>
                    {
                        publisher?.otherInfo?.isStoreSettingComplete ?
                            <AccordionPanel pb={4}>
                                <Text fontSize="md" color="green.600">
                                    <Text as="span">Congratulations you have filled up all the store information.</Text>
                                </Text>
                            </AccordionPanel> :
                            <AccordionPanel pb={4}>
                                <Text fontSize="md" color="gray.600">
                                    <Text as="span">Update Store Information lets you manage and display accurate details about your store, including its logo, video description, about. Keeping this information updated ensures customers see the latest and most relevant details on your website.</Text>
                                </Text>
                                <NavLink to={`/storesettings`} onClick={() => addBreadcrumb("Store Settings", "/storesettings", true)}>
                                    <Button mt={3} colorScheme="blue" fontWeight="regular">
                                        Go To <Text as="span" ml={1} fontWeight="800">Store Setting</Text>
                                    </Button>
                                </NavLink>
                            </AccordionPanel>
                    }
                </AccordionItem>

                {/* Step 3 */}
                <AccordionItem background="#fff" borderRadius="5px" border="none" padding="10px 8px">
                    <AccordionButton>
                        <Icon as={CheckCircleIcon} color={publisher?.otherInfo?.isOnBoardingCompleted ? "green.500" : "gray.500"} />
                        <Flex flex="1" textAlign="left" paddingLeft={2}>
                            <Text fontWeight="bold">Payment gateway</Text>
                        </Flex>
                        <AccordionIcon />
                    </AccordionButton>
                    {
                        publisher?.otherInfo?.isOnBoardingCompleted ?
                            <AccordionPanel pb={4}>
                                <Text fontSize="md" color="green.500">
                                    <Text as="span">Stripe itegration successfully completed.</Text>
                                </Text>
                            </AccordionPanel> :
                            <AccordionPanel pb={4}>
                                <Text fontSize="md" color="gray.500">
                                    <Text as="span" fontWeight="800">Edshopify</Text> seamlessly integrates with Stripe, enabling secure global payments with ease. If you don’t have a Stripe account, you can quickly apply and connect it within minutes. Start accepting payments instantly without any technical hassles.
                                </Text>
                                {
                                    stripeOnboardingUrl ?
                                        <Link href={stripeOnboardingUrl}>
                                            <Button mt={3} colorScheme="blue" fontWeight="regular">
                                                Connect with <Text as="span" ml={1} fontWeight="800">Stripe</Text>
                                            </Button>
                                        </Link> :
                                        <Button mt={3} colorScheme="blue" fontWeight="regular" onClick={onboarding}>
                                            Connect with <Text as="span" ml={1} fontWeight="800">Stripe</Text>
                                        </Button>
                                }
                            </AccordionPanel>
                    }
                </AccordionItem>
            </Accordion>
        </Box>
    );
};
